(function ($) {

    function setWidth() {
        var mq = window.matchMedia('(min-width: 960px)');
        var menuBar = $('.menubar');

        menuBar.off('menu');

        if (mq.matches) {
            menuBar.on('click.menu', function () {
                $('.sidenav').width('33%');
            });
        } else {
            mq = window.matchMedia('(min-width: 768px)');

            if (mq.matches) {
                menuBar.on('click.menu', function () {
                    $('.sidenav').width('50%');
                });
            } else {
                menuBar.on('click.menu', function () {
                    $('.sidenav').width('100%');
                });
            }
        }
    }

    $('.closebtn').on('click', function () {
        $('.sidenav').width('0px');
        setWidth();
    });

    $(window).on('resize', function () {
        setWidth();
    });

    setWidth();

}(jQuery));



// WEBPACK FOOTER //
// ./resources/assets/js/sidebar.js